export default function () {
  return [
    {
      collection_many: 'member_seating_status',
      collection_one: 'directus_users',
      field_many: 'user'
    },

    {
      collection_many: 'member_seating_status',
      collection_one: 'now_options',
      field_many: 'now'
    }
  ]
}
